'use client';
import { useQuery } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import { QueryApi } from '@/features/query/api';
import { useGetLocalizedValue } from '@/shared/lib/hooks/useGetLocalizedValue';
import { BackButton } from '@/shared/ui/back-button';
import { Icon } from '@/shared/ui/icon';
import './alergens.scss';

export const Alergens = () => {
    const t = useTranslations();
    const getLocalizedValue = useGetLocalizedValue();
    const { data: allergens = [] } = useQuery(QueryApi.Allergens.queries.Allergens);

    const sortedAllergens = [...allergens].sort((a, b) => a.sortIndex - b.sortIndex);

    return (
        <div className="alergens">
            <BackButton />
            <h1 className="alergens__title" data-testid="alergens-title">
                {t('ALERGENS.TITLE')}
            </h1>
            <p className="alergens__description" data-testid="alergens-description">
                {t('ALERGENS.DESCRIPTION')}
            </p>
            <div className="alergens__list">
                {sortedAllergens.map((allergen, index) => {
                    const code = allergen.code ?? String(allergen.sortIndex || index + 1);
                    const name = getLocalizedValue(allergen.name);
                    const description = allergen.description ? getLocalizedValue(allergen.description) : null;
                    return (
                        <div key={allergen.id} className="alergens__item">
                            <div className="alergens__icon-box">
                                <span className="alergens__number" data-testid={`alergen-number-${index}`}>
                                    {code}
                                </span>
                                <Icon name="wheat" width={24} height={24} />
                            </div>
                            <div className="alergens__content">
                                <span className="alergens__name" data-testid={`alergen-name-${index}`}>
                                    {name}
                                </span>
                                {description ? (
                                    <span
                                        className="alergens__info"
                                        data-testid={`alergen-description-${index}`}
                                    >
                                        {description}
                                    </span>
                                ) : null}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
